import { StaffRegistry } from "./StaffRegistry";

/**
 * Shared singleton instance of StaffRegistry for the entire app.
 * All staff data (calendar, modal, etc.) is merged into and read from this instance.
 */
let staffRegistryInstance: StaffRegistry | null = null;

export function getStaffRegistry(): StaffRegistry {
  if (!staffRegistryInstance) {
    staffRegistryInstance = new StaffRegistry();
  }
  return staffRegistryInstance;
}
